<template>
    <v-main>
        <v-app-bar dense flat height="80" class="pt-2 header">
            <header-block />
            <v-spacer />
            <div class="d-flex">
                <slot name="appBar" :is-new-template="isNewTemplate" />
                <v-btn
                    :disabled="isLoading"
                    :loading="isLoading"
                    color="primary"
                    variant="flat"
                    class="mr-2"
                    @click="isNewTemplate ? saveNew() : save()"
                >
                    {{ isNewTemplate ? $t('save') : $t('save_changes') }}
                </v-btn>
                <v-btn color="secondary" variant="flat" :to="{name}">
                    {{ $t('cancel') }}
                </v-btn>
            </div>
        </v-app-bar>
        <client-only>
            <div class="d-flex full-height wrapper" :class="contentClass">
                <slot />
            </div>
        </client-only>
    </v-main>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import HeaderBlock from '~src/components/snippets/headerBlock.src'

    @Component({
        components: {
            HeaderBlock,
        },
    })
    export class TemplateEditorPageLayout extends Vue {
        @Prop() contentClass
        @Prop({default: false, type: Boolean}) isLoading
        @Prop({default: 'emailTemplates', type: String}) name

        documentLanguage = ''

        @Emit()
        save() {
            return this.documentLanguage
        }

        @Emit()
        saveNew() {
            return this.documentLanguage
        }

        @Emit()
        changeLanguage() {
            return this.documentLanguage
        }

        get isNewTemplate() {
            return !this.$route.params.id
        }
    }

    export default TemplateEditorPageLayout
</script>

<style scoped lang="scss">
    .header {
        border-bottom: 1px #eeeeee solid;
        z-index: 100;
        background: white !important;
    }

    .wrapper {
        line-height: 0;
    }
</style>
